
import { ArtistTrackModel } from '@/models'
import { setSeoMeta } from '@/seo'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Artist extends Vue {
    loader = true
    view = 'tracks'
    error = null

    get artistInfo () {
        return this.$store.getters['artistModule/getArtistInfo'][0]
    }

    get tracks () {
        return this.$store.getters['trackModule/getTracks'][0]? this.$store.getters['trackModule/getTracks'][0]: []
    }
    get albums () {
        return this.$store.getters['albumModule/getAlbums']?this.$store.getters['albumModule/getAlbums']:[]
    }
    get songs () {
        return this.tracks.tracks?this.tracks.tracks:[]
    }

    get audio () {
        return this.$store.getters['getAudio']
    }

    get current () {
        return this.$store.getters['getCurrent']
    }

    coverStyle(image?: string, name?: string) {
        if (image && image.trim() && image.indexOf('url("")') === -1) {
            return { backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5)), url(${image})` }
        }
        const str = name || 'fallback';
        let hash = 0;
        for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
        const hue = Math.abs(hash) % 360;
        return {
            backgroundImage: `linear-gradient(135deg, hsl(${hue}, 70%, 20%), hsl(${(hue + 40) % 360}, 80%, 15%))`
        }
    }

    playAlbum(id: string) {
        this.$store.dispatch('trackModule/fetchAlbumTracks', id).then((response) => {
            response[0].tracks.map((track: ArtistTrackModel) => {
                track['artist_name'] = response[0].artist_name
                track.image = response[0].image
            })
            this.$store.commit('setTracksQueue', response[0].tracks)
            this.$store.commit('playTrack', response[0].tracks[0])
            this.audio.src = response[0].tracks[0].audio
            this.audio.play()
        })
    }

    convertTime (secs: number | string) {
        const totalSec = Math.floor(Number(secs) || 0);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    playSong (track: ArtistTrackModel, queue: ArtistTrackModel[]) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }

    updateArtistSeo() {
        const artist = this.artistInfo
        if (!artist || !artist.name) {
            return
        }

        setSeoMeta({
            title: `${artist.name} Songs and Albums | Robopol Music`,
            description: `Listen to ${artist.name} on Robopol Music. Browse tracks, albums, and independent music releases.`,
            path: this.$route.path,
            heading: artist.name,
            summary: `Browse ${artist.name} tracks and albums on Robopol Music.`,
            image: artist.image,
            imageAlt: `${artist.name} artist image`,
            schemaType: 'MusicGroup',
        })
    }

    mounted () {
        window.scrollTo(0,0);
        this.$store.dispatch('artistModule/fetchArtistInfo', this.$route.params.id).then(() => {
            this.loader = false
            this.updateArtistSeo()
        }).catch((error)=> {
            this.loader = false
            this.error = error
        })
        this.$store.dispatch('trackModule/fetchArtistTracks', this.$route.params.id).then((response) => {
            if (response.length > 0) {
                response[0].tracks.map((track: ArtistTrackModel) => {
                    track['artist_name'] = response[0].name
                })
            }
        })
        this.$store.dispatch('albumModule/fetchArtistAlbums', this.$route.params.id)
    }
}
